import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class IsyeriKonumuAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IsyeriKonumuListe";
    super(baseUrl);
  }


  getIsyeriKonumuListe( request?: any){
    return this.get("",request);
  }

}
export default new IsyeriKonumuAPI();
class IsyeriKonumuRequest {
  public IsyeriKonumuKodu?: number;

  constructor( kullanimSekliKodu?: number) {
   
        this.IsyeriKonumuKodu = kullanimSekliKodu;

  }
}
export { IsyeriKonumuRequest };